(() => {
  'use strict';

  const root = document.querySelector(
    '[data-dg-lab-tool="ghosting"]'
  );

  if (!root) return;

  if (root.dataset.dgLabGhostingInitialized === 'true') return;
  root.dataset.dgLabGhostingInitialized = 'true';

  const DIAG = {
    clean: {
      label: 'Movimiento limpio',
      score: 9.2,
      text: 'No has indicado artefactos visibles importantes.',
      tips: [
        'Mantén el ajuste actual de overdrive.',
        'Repite con fondos claros y oscuros para confirmar.'
      ]
    },

    same: {
      label: 'Ghosting moderado',
      score: 6.2,
      text: 'La estela del mismo color sugiere transiciones de píxel algo lentas.',
      tips: [
        'Prueba un nivel de overdrive superior.',
        'Evita el nivel máximo si aparecen halos invertidos.'
      ]
    },

    dark: {
      label: 'Smearing visible',
      score: 4.8,
      text: 'La mancha oscura puede corresponder a transiciones oscuras lentas.',
      tips: [
        'Prueba varios fondos y niveles de overdrive.',
        'En paneles VA puede ser más visible en escenas oscuras.'
      ]
    },

    inverse: {
      label: 'Overshoot probable',
      score: 4.5,
      text: 'El halo invertido suele aparecer cuando el overdrive es demasiado agresivo.',
      tips: [
        'Reduce un nivel el overdrive.',
        'Compara a distintas frecuencias y con VRR activo.'
      ]
    },

    multiple: {
      label: 'Persistencia o artefacto notable',
      score: 3.8,
      text: 'Los contornos múltiples pueden indicar respuesta lenta, estroboscopia o sincronización inadecuada.',
      tips: [
        'Comprueba la frecuencia estimada del monitor.',
        'Desactiva temporalmente funciones de reducción de desenfoque.'
      ]
    }
  };

  const stage = root.querySelector('#stage');
  const orb = root.querySelector('#orb');
  const speed = root.querySelector('#speed');
  const startButton = root.querySelector('#start');
  const fullButton = root.querySelector('#full');
  const textColorControl = root.querySelector('#textColorControl');

  if (
    !stage ||
    !orb ||
    !speed ||
    !startButton ||
    !fullButton
  ) {
    return;
  }

  const reduceMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  let origin = performance.now();
  let running = false;
  let raf = 0;
  let wasRunning = false;

  let currentPattern = 'sphere';
  let currentTextColor = '#ffffff';

  function get(id) {
    return root.querySelector('#' + id);
  }

  function setStatus(text) {
    const status = root.querySelector(
      '.motion-hud .help'
    );

    if (status) {
      status.textContent = text;
    }
  }

  function stop(label = 'Iniciar') {
    running = false;

    if (raf) {
      cancelAnimationFrame(raf);
    }

    raf = 0;
    startButton.textContent = label;
  }

  function loop(time) {
    if (
      !running ||
      document.hidden ||
      reduceMotion.matches
    ) {
      return;
    }

    const value = Number(speed.value);
    const travelWidth = stage.clientWidth + 260;

    const x =
      (((time - origin) / 1000) * value) %
        travelWidth -
      140;

    orb.style.transform =
      `translate3d(${x}px, -50%, 0)`;

    const lap = travelWidth / value;

    const lapElement = get('lap');

    if (lapElement) {
      lapElement.textContent =
        lap.toLocaleString(
          'es-ES',
          {
            maximumFractionDigits: 2
          }
        );
    }

    raf = requestAnimationFrame(loop);
  }

  function start() {
    if (running) return;

    if (reduceMotion.matches) {
      setStatus(
        'Movimiento reducido activo. Desactiva esta preferencia del sistema para ejecutar la prueba.'
      );

      return;
    }

    running = true;
    origin = performance.now();

    startButton.textContent = 'Detener';

    setStatus(
      'Sigue el objeto con la mirada y observa su contorno.'
    );

    raf = requestAnimationFrame(loop);
  }

  async function toggleFullscreen(target) {
    if (
      !target ||
      !document.fullscreenEnabled
    ) {
      setStatus(
        'Pantalla completa no disponible.'
      );

      return;
    }

    try {
      if (document.fullscreenElement) {
        await document.exitFullscreen();
      } else {
        await target.requestFullscreen();
      }
    } catch (error) {
      setStatus(
        'Pantalla completa no disponible.'
      );
    }
  }

  function applyTextColor() {
    if (currentPattern === 'text') {
      orb.style.color = currentTextColor;
    } else {
      orb.style.removeProperty('color');
    }
  }

  function setPattern(pattern, label) {
    currentPattern = pattern;

    /*
     * Base:
     * motion-object = esfera_deeplab.png
     * square        = bloque
     * text          = DEEPGAMING
     */
    orb.className = 'motion-object';
    orb.textContent = '';

    if (pattern === 'square') {
      orb.classList.add('square');
    } else if (pattern === 'text') {
      orb.classList.add('text');
      orb.textContent = 'DEEPGAMING';
    }

    const patternElement = get('pattern');

    if (patternElement) {
      patternElement.textContent = label;
    }

    if (textColorControl) {
      textColorControl.hidden =
        pattern !== 'text';
    }

    applyTextColor();
  }

  function setBackground(type) {
    if (type === 'light') {
      stage.style.background =
        'linear-gradient(180deg, #e7edf8, #c9d5ea)';

      return;
    }

    if (type === 'contrast') {
      stage.style.background =
        'repeating-linear-gradient(' +
        '90deg,' +
        '#05070c 0 70px,' +
        '#e7ecf5 70px 140px' +
        ')';

      return;
    }

    stage.style.background =
      'linear-gradient(180deg, #0b1120, #080c16)';
  }

  startButton.addEventListener(
    'click',
    () => {
      if (running) {
        stop();
      } else {
        start();
      }
    }
  );

  speed.addEventListener(
    'input',
    () => {
      const pps = get('pps');
      const speedValue = get('speedValue');

      if (pps) {
        pps.textContent = speed.value;
      }

      if (speedValue) {
        speedValue.textContent =
          speed.value + ' px/s';
      }
    }
  );

  root
    .querySelectorAll('.pattern-btn')
    .forEach((button) => {
      button.addEventListener(
        'click',
        () => {
          root
            .querySelectorAll('.pattern-btn')
            .forEach((item) => {
              item.setAttribute(
                'aria-pressed',
                'false'
              );
            });

          button.setAttribute(
            'aria-pressed',
            'true'
          );

          setPattern(
            button.dataset.pattern,
            button.textContent.trim()
          );
        }
      );
    });

  root
    .querySelectorAll('.text-color-btn')
    .forEach((button) => {
      button.addEventListener(
        'click',
        () => {
          root
            .querySelectorAll('.text-color-btn')
            .forEach((item) => {
              item.setAttribute(
                'aria-pressed',
                'false'
              );
            });

          button.setAttribute(
            'aria-pressed',
            'true'
          );

          currentTextColor =
            button.dataset.color || '#ffffff';

          applyTextColor();
        }
      );
    });

  root
    .querySelectorAll('.bg-btn')
    .forEach((button) => {
      button.addEventListener(
        'click',
        () => {
          root
            .querySelectorAll('.bg-btn')
            .forEach((item) => {
              item.setAttribute(
                'aria-pressed',
                'false'
              );
            });

          button.setAttribute(
            'aria-pressed',
            'true'
          );

          setBackground(
            button.dataset.bg
          );
        }
      );
    });

  root
    .querySelectorAll('.choice-btn')
    .forEach((button) => {
      button.addEventListener(
        'click',
        () => {
          root
            .querySelectorAll('.choice-btn')
            .forEach((item) => {
              item.setAttribute(
                'aria-pressed',
                'false'
              );
            });

          button.setAttribute(
            'aria-pressed',
            'true'
          );

          const data =
            DIAG[button.dataset.answer];

          if (!data) return;

          const badge = get('diagBadge');
          const title = get('diagTitle');
          const score = get('diagScore');
          const text = get('diagText');
          const tips = get('diagTips');
          const state = get('state');

          if (badge) {
            badge.textContent =
              'Completado';
          }

          if (title) {
            title.textContent =
              data.label;
          }

          if (score) {
            score.textContent =
              data.score.toLocaleString(
                'es-ES',
                {
                  minimumFractionDigits: 1,
                  maximumFractionDigits: 1
                }
              ) + '/10';
          }

          if (text) {
            text.textContent =
              data.text;
          }

          if (tips) {
            tips.replaceChildren(
              ...data.tips.map((tip) => {
                const li =
                  document.createElement('li');

                li.textContent = tip;

                return li;
              })
            );
          }

          if (state) {
            state.textContent =
              'Completado';
          }
        }
      );
    });

  fullButton.addEventListener(
    'click',
    () => {
      toggleFullscreen(stage);
    }
  );

  document.addEventListener(
    'fullscreenchange',
    () => {
      if (
        document.fullscreenElement === stage
      ) {
        setStatus(
          'Pantalla completa activa · Pulsa Esc para salir'
        );
      } else {
        setStatus(
          'Sigue el objeto con la mirada y observa su contorno.'
        );
      }
    }
  );

  document.addEventListener(
    'visibilitychange',
    () => {
      if (document.hidden) {
        wasRunning = running;

        if (running) {
          stop();
        }

        return;
      }

      if (wasRunning) {
        wasRunning = false;
        start();
      }
    }
  );

  window.addEventListener(
    'pagehide',
    () => {
      stop('Iniciar');
    },
    {
      once: true
    }
  );

  /*
   * Estado inicial.
   */
  setPattern(
    'sphere',
    'Esfera'
  );

  setBackground('dark');
})();